import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/credit-suisse-cop-hackathon-sept16/credit-suisse-cop-hackathon-sept16/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Azure Platform-as-a-Service (PaaS) services provide flexible ways to run workloads, securely and reliably on the cloud.`}</p>
    </PageDescription>
    <h3>{`Azure Compute Services`}</h3>
    <p><a parentName="p" {...{
        "href": "https://docs.microsoft.com/en-us/azure/?product=compute&ocid=AID3054457"
      }}>{`Azure Documentation - Compute Services`}</a></p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure Container Instances`}</strong>{`: Run Docker containers on-demand in a managed, serverless Azure environment. `}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/container-instances/&ocid=AID3054457"
            }}>{`Docs`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/training/modules/run-docker-with-azure-container-instances/&ocid=AID3054457"
            }}>{`Learn Module`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure App Service`}</strong>{`:  Azure App Service enables you to build and host web apps, mobile back ends, and RESTful APIs in the programming language of your choice without managing infrastructure.`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/app-service/&ocid=AID3054457"
            }}>{`Docs`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/learn/modules/host-a-web-app-with-azure-app-service/&ocid=AID3054457"
            }}>{`Learn module`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure Static Web Apps`}</strong>{`: allows you to build modern web applications that automatically publish to the web as your code changes. Full-stack development combining Frontend (React, Angular, Vue, …), Serverless Backend API using Azure Functions (NodeJS, Python, C#,…) and GitHub Actions CI/CD pipeline. `}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://channel9.msdn.com/Shows/Docs-Azure/Building-and-Deploying-a-Static-Web-App/"
            }}>{`Video`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/static-web-apps/overview/&ocid=AID3054457"
            }}>{`Docs`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/learn/paths/azure-static-web-apps/&ocid=AID3054457"
            }}>{`Learning Path`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure Functions`}</strong>{` (Serverless): You can use Functions to build web APIs, respond to database changes, process IoT streams, manage message queues, and more.`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/azure-functions/&ocid=AID3054457"
            }}>{`Docs`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      